import React from "react";
import Intro from "../../Components/Intro";
import one from "../../Assets/new/slide/new/strsn.webp";
import two from "../../Assets/new/slide/new/green.webp";
import three from "../../Assets/new/slide/new/sunshine.webp";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import QuoteCards from "../../Components/QuoteCards";
import AgreeServicess from "../../Components/AgreeServicess";
import Supplies from "../../Components/Supplies";
import CustomerExp from "../../Components/CustomersExp";
import "../../App.css";
import Enquiry from "../../Components/Enquiry";
import CustomSlider from "../../Components/CustomSlider";
import TestimonialsSlider from "../../Components/TestimonialsSlider";
import gif from "../../Assets/gi.webm";

import front_page_poster from "../../Assets/front-page-poster.webp";
import { Helmet } from "react-helmet";

function Home() {
  var img = [
    {
      img: two,
      caption: "ROYAL GREEN HOUSE CONSTRUCTION(I) PVT. LTD.",
      subcaption:
        "We Are India's Fastest Growing Hi-Tech Polyhouse (Hydroponics) Setup Company.",
      moto: "Build Your Own affordable Hydroponic Farm With Our Expertise (At home also)",
    },
    {
      img: one,
      caption: "ROYAL GREEN HOUSE CONSTRUCTION(I) PVT. LTD.",
      subcaption:
        "We Are the largest project developer in hydroponic farming and soil-less farming.",
      moto: "The Best Harvests Anywhere In The World",
    },
    {
      img: three,
      caption: "ROYAL GREEN HOUSE CONSTRUCTION(I) PVT. LTD.",
      subcaption:
        "Leader In Vertical Hydroponic Farming With 40 To 60% Higher Revenue.",
      moto: "Build Extremely Profitable Hydroponic Farm With Us.",
    },
  ];
  return (
    <>
      <Helmet>
        <link rel="preload" as="image" href={front_page_poster} />
      </Helmet>

      <div
        className="hero-wrapper"
        style={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <img
          src={front_page_poster}
          alt="Front Page Poster"
          className="hero-image"
        />
        {/* Overlay text */}
        <div
          id="contentVid"
          className="position-absolute start-0"
          style={{
            top: "150px",
            left: "30px",
            color: "white",
            width: "auto",
          }}
        >
          <div className="py-5 text-center text-lg-start w-100">
            <h1 className="fw-bold">
              {/* Main Heading */}
              <span className="d-block display-5 display-md-3 mb-3 fw-bold">
                ROYAL GREEN ENERGY
              </span>

              {/* Subheading */}
              <span className="d-block fs-4 fs-md-2 mb-2">
                Precision-Engineered Electrical Materials
              </span>

              <span className="d-block fs-5 fs-md-4 mb-2">
                Trusted by Industries Across India
              </span>
              <span className="d-block fs-5 fs-md-4">
                Specializing in High-Strength Pole line, Tower line & Distribution
                Hardware. Get Reliable, Durable & Project-Ready Components for
                Every Power Installation
              </span>
            </h1>
          </div>
        </div>
      </div>

      {/* <Banner /> */}
      {/* <Slider images={img} /> */}
      {/* <QuoteCards /> */}

      <Container className="whitebgimg p-4" fluid>
        <Row>
          <Col lg={6} className="p-4 mt-2">
            <h5 className="p-2 hover-text" style={{ display: "inline" }}>
              LEADER IN INDUSTRIAL ELECTRICAL MATERIAL MANUFACTURING
            </h5>
            <h5 className="p-2 hover-text" style={{ display: "inline" }}>
              WITH HIGH-STRENGTH, UTILITY-GRADE PRODUCTS.
            </h5>

            <h5 className="p-2 hover-text">
              NO MATTER THE SITE OR SCALE, WE DELIVER PROJECT-READY MATERIAL
              ACROSS PAN INDIA.
            </h5>
            <h5 className="p-2 hover-text">
              WE MANUFACTURE WITH PRECISION – YOU BUILD WITH RELIABILITY.{" "}
            </h5>
            <h3 className="p-2 text-green">
              More Details :<a href="tel:+919890099992"> +91-9890-099-992</a>
            </h3>
          </Col>
          <Col lg={4} className="p-4 mt-3">
            <video
              src={gif}
              autoPlay
              muted
              loop
              playsInline
              className="img-fluid rounded"
              style={{ maxWidth: "100%", height: "auto" }}
            >
              Your browser does not support the video tag.
            </video>
          </Col>
        </Row>
      </Container>

      {/* Text below the video */}
      <Container>
        {/* <Row>
          <Col>
            <h5 className="text-start">
              Hi-Tech Polyhouse and Hydroponics Farm Setup in India
            </h5>
          </Col>
        </Row> */}
      </Container>
      <Intro />
      <Supplies />
      <AgreeServicess />

      {/* <TestimonialsSlider /> */}
      {/* <CustomerExp reviewData="reviewData" /> */}
      <CustomSlider />
      {/* <Press /> */}
      <Enquiry />
      {/* <PopupMessage /> */}
    </>
  );
}
export default Home;
